import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const SimpleTemplate = ({
  height = 80,
  width = 72,
  color = colors.white,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} {...props}>
    <rect width="71.1111" height="80" rx="4" fill={getColor(color, isColorInherited)} />
    <rect x="7.11108" y="7.11108" width="56.8889" height="32" rx="2" fill="#E0DEDF" />
    <line
      x1="8.11108"
      y1="45.2222"
      x2="63"
      y2="45.2222"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="8.11108"
      y1="52.3333"
      x2="63"
      y2="52.3333"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="8.11108"
      y1="59.4443"
      x2="44.3333"
      y2="59.4443"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </SvgIcon>
);
